<template>
  <v-container fluid class="pa-6 pa-md-8">
    <div class="page-head">
      <h1 class="page-head__title">Deactivated Staff</h1>
      <p class="page-head__sub">
        Staff members that have been deactivated. Only deactivated staff appear
        here.
      </p>
    </div>

    <div class="toolbar d-flex align-center mb-4">
      <v-text-field
        outlined
        dense
        rounded
        hide-details
        prepend-inner-icon="mdi-magnify"
        placeholder="Search staff…"
        v-model="search"
        color="primary"
        class="toolbar__search"
      />
    </div>

    <v-alert
      v-show="alert"
      type="success"
      dense
      text
      class="mb-4"
    >
      {{ message }}
    </v-alert>

    <v-data-table
      :headers="headers"
      :items="staffList"
      :loading="progress"
      item-key="_id"
      :server-items-length="total"
      :options.sync="options"
      class="data-table"
      loading-text="Loading… Please wait"
      :search="search"
    >
      <template #item.avatar="{ item }">
        <v-avatar size="36" class="cell-avatar">
          <span>{{ item.name | firstLetterFunction }}</span>
        </v-avatar>
      </template>
      <template #item.name="{ item }">
        <span class="cell-strong text-capitalize">{{ item.name }}</span>
      </template>
      <template #item.accountNumber="{ item }">
        <span class="tabular">{{ item.accountNumber }}</span>
      </template>
      <template #item.phone="{ item }">
        <span class="tabular">{{ item.phone }}</span>
      </template>
      <template #item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              icon
              small
              class="cell-action"
              @click="restore(item)"
            >
              <v-icon small>mdi-backup-restore</v-icon>
            </v-btn>
          </template>
          <span>Restore staff member</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import axios from "axios";
import { getAuthToken } from "@/utils/helpers";

export default {
  name: "RemovedStaff",
  data() {
    return {
      alert: false,
      message: "",
      progress: false,
      search: "",
      total: 0,
      options: {
        page: 1,
        itemsPerPage: 10
      },
      staff: []
    };
  },

  computed: {
    staffList() {
      return this.staff.filter(searchTerm => {
        return (
          searchTerm.name.toLowerCase().indexOf(this.search.toLowerCase()) !==
          -1
        );
      });
    },

    headers() {
      return [
        { text: "", value: "avatar", filterable: false, sortable: false },
        {
          text: "Staff Name",
          value: "name",
          filterable: true,
          sortable: false
        },
        {
          text: "Account Number",
          value: "accountNumber",
          filterable: false,
          sortable: false
        },
        { text: "Phone", value: "phone", filterable: false, sortable: false },
        { text: "Actions", value: "actions", filterable: false, sortable: false }
      ];
    }
  },
  filters: {
    firstLetterFunction(value) {
      return value ? value.charAt(0).toUpperCase() : "";
    }
  },

  watch: {
    options: {
      handler(value) {
        this.listStaff(value.page, value.itemsPerPage);
      },
      deep: true
    }
  },

  methods: {
    listStaff(page, itemsPerPage) {
      this.progress = true;
      axios({
        method: "get",
        headers: {
          authorization: `Bearer ${getAuthToken()}`
        },
        url: `${process.env.VUE_APP_BASE_URL}/api/v1/staffs/with/trash?paginated=true&page=${page}&limit=${itemsPerPage}`
      })
        .then(response => {
          if (response.status === 200) {
            this.progress = false;
            this.staff = response.data.data.docs;
            this.options.page = response.data.data.page;
            this.options.itemsPerPage = parseInt(response.data.data.limit);
            this.total = response.data.data.total;
          }
        })
        .catch(err => {
          this.progress = false;
          if (err.response && err.response.status === 401) {
            this.$router.replace({ name: "account.login" });
          }
        });
    },

    restore(item) {
      this.$store.dispatch("staffs/restore", item._id);
      setTimeout(() => {
        this.listStaff(this.options.page, this.options.itemsPerPage);
      }, 800);
    }
  },
  created() {
    this.listStaff(this.options.page, this.options.itemsPerPage);
  }
};
</script>

<style scoped>
.toolbar__search {
  max-width: 440px;
  width: 100%;
}
.cell-avatar {
  background: var(--signal-soft);
  color: var(--signal);
  font-size: 13px;
  font-weight: 600;
}
.cell-strong {
  font-weight: 600;
  color: var(--foreground);
}
.cell-action {
  color: var(--muted-foreground) !important;
}
.cell-action:hover {
  color: var(--status-delivered) !important;
}
</style>
